<template>
  <site-header @auth-updated="$emit('auth-updated')" />
</template>

<script>
import SiteHeader from '@/components/home/SiteHeader.vue'

export default {
  name: 'ScholarHeader',
  components: { SiteHeader }
}
</script>
